import React, { Dispatch, SetStateAction } from 'react'

import { Button } from 'primereact/button'
import { MultiSelect } from 'primereact/multiselect'
import { TableColumn } from 'utils/types'

type TableColumnSelectionProps = {
  customColumns: string[];
  setCustomColumns: Dispatch<SetStateAction<string[]>>;
  mapCol: TableColumn<any>[];
  handleColumnSave: () => void;
  loading: boolean;
};

const TableColumnSelection: React.FC<TableColumnSelectionProps> = ({
  customColumns,
  setCustomColumns,
  handleColumnSave,
  mapCol,
  loading,
}) => {
  return (
    <div className="p-inputgroup w-max">
      <MultiSelect
        value={customColumns}
        options={mapCol}
        optionValue="header"
        optionLabel="header"
        onChange={e => setCustomColumns(e.value)}
        maxSelectedLabels={0}
        placeholder="Columns"
        panelHeaderTemplate
        selectedItemsLabel="Columns"
      />
      <Button
        icon="pi pi-save"
        className="p-inputgroup-addon p-button-warning"
        title="Save table columns"
        onClick={handleColumnSave}
        loading={loading}
      />
    </div>
  );
};

export default TableColumnSelection